import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { business } from '../data/business';
const EASE = [0.23, 1, 0.32, 1] as const;
const STORAGE_KEY = 'hf-intro-seen';
/** How long the logo keeps spinning before the page is revealed. */
const HOLD_MS = 2600;
export function IntroSplash() {
  const reduceMotion = useReducedMotion();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (reduceMotion) return;
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;
    setVisible(true);
    sessionStorage.setItem(STORAGE_KEY, '1');
    const timer = window.setTimeout(() => setVisible(false), HOLD_MS);
    return () => window.clearTimeout(timer);
  }, [reduceMotion]);
  useEffect(() => {
    if (!visible) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [visible]);
  return <AnimatePresence data-id="element-221" data-mp="3cnts3web37db">
      {visible && <motion.div key="intro" className="fixed inset-0 z-[100] overflow-hidden" aria-hidden="true" data-id="element-222" data-mp="3cpmydal0bpks">
          <motion.div className="absolute inset-x-0 top-0 h-1/2 bg-ink" initial={{
        y: 0
      }} exit={{
        y: '-100%'
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} data-id="element-223" data-mp="33vru04rpm367" />
          <motion.div className="absolute inset-x-0 bottom-0 h-1/2 bg-ink" initial={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} data-id="element-224" data-mp="3vng22f3gg3j8" />

          <motion.div className="relative flex h-full w-full flex-col items-center justify-center px-8" exit={{
        opacity: 0,
        scale: 0.98
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} data-id="element-225" data-mp="3ml6sbrg0ge6w">
            <div className="relative flex h-44 w-44 items-center justify-center sm:h-56 sm:w-56" data-id="element-226" data-mp="2b8e0yhr4trrd">
              {/* Gold ring spinning the opposite way for depth */}
              <motion.span className="absolute inset-0 rounded-full border-2 border-transparent border-t-gold border-r-gold/40" animate={{
            rotate: -360
          }} transition={{
            duration: 1.6,
            ease: 'linear',
            repeat: Infinity
          }} data-id="element-227" data-mp="27q8ajjvz057r" />
              <motion.img src={business.logo} alt="" className="h-36 w-36 rounded-full object-cover sm:h-48 sm:w-48" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1,
            rotate: 360
          }} transition={{
            opacity: {
              duration: 0.28,
              ease: EASE
            },
            scale: {
              duration: 0.28,
              ease: EASE
            },
            rotate: {
              duration: 1.3,
              ease: 'linear',
              repeat: Infinity
            }
          }} data-id="element-228" data-mp="23msfgrzjucx6" />
            </div>

            <motion.p className="mt-8 text-center font-display text-xs uppercase tracking-[0.4em] text-gold" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.32,
          ease: EASE
        }} data-id="element-229" data-mp="1625uwdrxol4f">
              Haircuts Factory · Dundee, FL
            </motion.p>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}